enum ProjectListColumnNames {
  ProjectName = 'Project Name',
  ClientName = 'Client Name',
  ProjectCode = 'Project Code',
  ProjectManager = 'Project Manager',
  ProjectStatus = 'Status'
}

export default ProjectListColumnNames;
